<script lang="ts" setup>
import { computed, ref, watch } from 'vue';
import BaseIcon from './BaseIcon.vue';

export type AvatarProps = {
  imgUrl?: string;
  text?: string;
  color?: string;
};

const props = defineProps<AvatarProps>();

const imgNotFound = ref(false);

const showImg = computed(() => props.imgUrl && !imgNotFound.value);

watch(
  () => props.imgUrl,
  () => {
    imgNotFound.value = false;
  }
);

function onImgError() {
  imgNotFound.value = true;
}
</script>

<template>
  <v-avatar :color="props.color || 'primary-400'">
    <slot>
      <v-img
        v-if="showImg"
        :src="props.imgUrl"
        :alt="props.text || ''"
        @error="onImgError"
      />
      <template v-if="!showImg">
        <span
          v-if="props.text"
          class="text-header"
        >{{ props.text }}</span>
        <BaseIcon
          v-else
          icon="mdi-account"
          :size="36"
        />
      </template>
    </slot>
  </v-avatar>
</template>
<style scoped lang="scss">
.v-avatar {
  border: 1px solid rgb(var(--v-theme-grey-150)) !important;
}
</style>
